import { render, staticRenderFns } from "./VouchersClientsTable.vue?vue&type=template&id=5409f288&scoped=true"
import script from "./VouchersClientsTable.vue?vue&type=script&lang=js"
export * from "./VouchersClientsTable.vue?vue&type=script&lang=js"
import style0 from "./VouchersClientsTable.vue?vue&type=style&index=0&id=5409f288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5409f288",
  null
  
)

export default component.exports